import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import boxArchiveSolid from '../../../../assets/images/box-archive-solid.svg'
import paletteOutline from '../../../../assets/images/palette-outline.svg'

const ExportChoiceCards = ({
  exportAllTitle,
  exportAllDescription,
  customizeDescription,
  onExportAll,
  onCustomize
}) => {
  const handleExportAllClick = useCallback(() => {
    onExportAll()
  }, [onExportAll])

  const handleCustomizeClick = useCallback(() => {
    onCustomize()
  }, [onCustomize])

  return (
    <div className="export-type">
      <div className="row">
        <div className="col-md-6">
          <div
            className="card"
            role="button"
            tabIndex={0}
            onClick={handleExportAllClick}
          >
            <div className="card-body">
              <div className="text-center mb-3">
                <h4 className="card-title">{exportAllTitle}</h4>
                <img
                  src={boxArchiveSolid}
                  className="d-inline-block"
                  style={{ height: '3.5rem' }}
                  alt="Export all"
                />
              </div>
              <p className="card-text text-center">{exportAllDescription}</p>
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div
            className="card"
            role="button"
            tabIndex={0}
            onClick={handleCustomizeClick}
          >
            <div className="card-body">
              <div className="text-center mb-3">
                <h4 className="card-title">Personnaliser l&apos;export</h4>
                <img
                  src={paletteOutline}
                  className="d-inline-block"
                  style={{ height: '3.5rem' }}
                  alt="Customize"
                />
              </div>
              <p className="card-text text-center">{customizeDescription}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

ExportChoiceCards.propTypes = {
  customizeDescription: PropTypes.string.isRequired,
  exportAllDescription: PropTypes.string.isRequired,
  exportAllTitle: PropTypes.string.isRequired,
  onCustomize: PropTypes.func.isRequired,
  onExportAll: PropTypes.func.isRequired
}

export default ExportChoiceCards
